import {Button, Icon, Switch} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {useTheme} from '../../theme/components/ThemeProvider';

import type {FC} from 'react';
import type React from 'react';

export const DarkModeToggle: FC = () => {
  const {theme, setTheme} = useTheme();
  const {t} = useTranslation('common');
  const isDark = theme === 'dark';

  return (
    <Button
      variant="tertiary"
      data-slot="account-menu-theme"
      className="h-auto w-full justify-start rounded-sm p-2 gap-3 font-semibold text-fg-secondary"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      <Icon name={isDark ? 'moon' : 'sun'} className="size-5 shrink-0 text-fg-tertiary" />
      <span className="flex-1 text-start">{t('theme.darkMode')}</span>
      <Switch
        checked={isDark}
        onCheckedChange={checked => setTheme(checked ? 'dark' : 'light')}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      />
    </Button>
  );
};
